import Vue from "vue";

import { nativeHealthCommandSchema, NativeHealthCommand } from "@/utils/healthBridgeSchemas";

type NativeTarget = {
  postMessage(message: string): unknown;
};

const getNativeTarget = (): NativeTarget | undefined => (Vue.prototype as Vue & { $native?: NativeTarget }).$native;

export const isHealthNativeBridgeAvailable = (): boolean => Boolean(getNativeTarget());

export const postHealthCommand = <TResponse = unknown>(
  command: NativeHealthCommand
): TResponse | PromiseLike<TResponse> | undefined => {
  const validatedCommand = nativeHealthCommandSchema.parse(command);
  return getNativeTarget()?.postMessage(JSON.stringify(validatedCommand)) as
    | TResponse
    | PromiseLike<TResponse>
    | undefined;
};
